import { Tooltip } from 'antd'
import type { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

import { SeverityEnum } from 'src/api/main/types.gen'
import { SEVERITY_COLORS, translateAuditSeverity } from 'src/utils'

type Props = {
  severity: SeverityEnum | string | undefined | null
  size?: number
  /** Disable the tooltip when the row already carries a separate severity tag. */
  withTooltip?: boolean
  style?: CSSProperties
}

export const SeverityDot = ({
  severity,
  size = 8,
  withTooltip = true,
  style
}: Props) => {
  const { t } = useTranslation()
  const known = severity as SeverityEnum
  const background = SEVERITY_COLORS[known] ?? 'var(--ant-color-text-tertiary)'

  const dot = (
    <span
      role="img"
      aria-label={severity ? translateAuditSeverity(t, String(severity)) : ''}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        background,
        ...style
      }}
    />
  )

  if (!withTooltip || !severity) return dot

  return (
    <Tooltip title={translateAuditSeverity(t, String(severity))}>{dot}</Tooltip>
  )
}
